import config from '../config/environment';
import supabase from '../config/supabase';
import {
  parsePaymentsDueDashboard,
  type PaymentsDueDashboard,
  type PaymentsDueQuery,
} from '../utils/paymentsDueDashboard';
import { handleServiceError } from '../utils/errorHandler';

class PaymentsDueServiceClass {
  async getDashboard(query: PaymentsDueQuery): Promise<PaymentsDueDashboard> {
    const token = await this.getAccessToken();
    const url = this.buildUrl(query);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: this.buildHeaders(token),
    });
    const body = await response.json().catch(() => ({})) as { error?: string };

    if (!response.ok) {
      handleServiceError(
        new Error(body.error || 'Erro ao carregar as alunas a vencer'),
        'carregar as alunas a vencer',
      );
    }

    const snapshot = parsePaymentsDueDashboard(body);
    if (!snapshot) {
      handleServiceError(
        new Error('Erro ao carregar as alunas a vencer'),
        'carregar as alunas a vencer',
      );
    }

    return snapshot;
  }

  private buildUrl(query: PaymentsDueQuery): URL {
    const url = new URL(`${config.supabaseFunctionsUrl}/payments-due`);
    url.searchParams.set('page', String(query.page));
    url.searchParams.set('pageSize', String(query.pageSize));

    const search = query.searchName.trim();
    if (search) {
      url.searchParams.set('search', search);
    }

    for (const gateway of query.paymentGateway) {
      url.searchParams.append('paymentSystem', gateway);
    }

    if (query.dueStart && query.dueEnd) {
      url.searchParams.set('dueStart', query.dueStart);
      url.searchParams.set('dueEnd', query.dueEnd);
    }

    if (query.overdueMinDays) {
      url.searchParams.set('overdueMinDays', query.overdueMinDays);
    }

    return url;
  }

  private async getAccessToken(): Promise<string | undefined> {
    const { data: sessionData } = await supabase.auth.getSession();
    return sessionData?.session?.access_token;
  }

  private buildHeaders(token: string | undefined): HeadersInit {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      apikey: config.supabaseAnonKey,
    };
  }
}

export const PaymentsDueService = new PaymentsDueServiceClass();
